export const SET_CAMPUS= "SET_CAMPUS"


export const setCampus = (value: any) => {
    return { type: SET_CAMPUS, value }
}